import icUserDefault from 'assets/images/ic-user-profile.svg'
import { formatDateMoment, setCurrency } from 'utils/utils'

export const TABLE_WISHLIST = {
    name: 'Wishlist',
    column: [
        {
            name: 'Produk',
            key: 'produk',
            render: ({ item }) => (
                <div className={'flex flex-row gap-3 items-center'}>
                    <img className={'w-7 h-7'} src={item?.image_url || icUserDefault} alt={item?.name} />
                    <div>{item?.name}</div>
                </div>
            ),
        },
        {
            name: 'SKU',
            key: 'sku',
            className: 'max-w-[300px] break-words',
        },
        {
            name: 'Category',
            key: 'categories',
            className: 'capitalize',
            render: ({ value }) => <div>{value?.replace(/,/g, ', ')}</div>,
        },
        {
            name: 'Price',
            key: 'price',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY HH:mm')}</div>,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    page: 1,
    limit: 20,
}
